import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT, VIEW, ASC } from "const"
import { MtProjectGroup } from "server/models"
import { StateType, deepCopy, hasProjectAccess } from "client/utils"
import {
    PRM_TEAM,
    StoreType,
    ProjectGroupList,

    LoadProjectGroups,
    LoadAllProjectGroupUsers,
    SortProjectGroups,
    DeleteProjectGroup,
    DragnDropProjectGroup,

    setProjectGroupList,
    setProjectGroupIds,
    setProjectGroupUserList,
    addModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    Button,
    Table,
    DeleteRow,
    DragnDrop,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import Columns from "./columns"
import Edit from "./edit"

const ProjectGroup = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)

    const groupList = useSelector((state: StoreType) => state.projectGroup.groupList)
    const groupIds = useSelector((state: StoreType) => state.projectGroup.groupIds)
    const reloadList = useSelector((state: StoreType) => state.projectGroup.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const LoadData = () => {
        if (!project.id) return
        setLoadState(PENDING)
        Promise.all([
            LoadProjectGroups(project.accountId, project.id, true)
            .then((res) => {
                dispatch(setProjectGroupList(res))
            }),
            LoadAllProjectGroupUsers(project.accountId, project.id, userList)
            .then((res) => {
                dispatch(setProjectGroupUserList(res))
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }

    useEffect(() => {
        if (!reloadList) return
        LoadData()
    }, [reloadList, project])

    useEffect(() => {
        const sortedIds = SortProjectGroups(Object.values(groupList), "order", ASC, {})
        dispatch(setProjectGroupIds(sortedIds))
    }, [groupList])

    const onDelete: DeleteRow = (group: MtProjectGroup, callback) => {
        DeleteProjectGroup(group.groupId, group.accountId, group.projectId).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const groupListCopy: ProjectGroupList = groupList ? deepCopy(groupList) : {}
                delete groupListCopy[group.groupId]
                dispatch(setProjectGroupList(groupListCopy))
            })
        })
    }

    const onDragnDrop: DragnDrop = (dataIds, callback) => {
        dispatch(setProjectGroupIds(dataIds))
        setLoadState(PENDING)
        DragnDropProjectGroup(dataIds, project.accountId, project.id).then((success) => {
            LoadData()
            callback(success)
        })
    }

    const columns = Columns()

    const viewAccess = hasProjectAccess(PRM_TEAM, VIEW)
    const editAccess = hasProjectAccess(PRM_TEAM, EDIT)

    if (!viewAccess) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.groups}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <Table
                    columns={columns}
                    dataList={groupList}
                    dataIds={groupIds}
                    rowSize="sm"
                    onDelete={onDelete}
                    onDragnDrop={onDragnDrop}
                    bottomContent={editAccess && (
                        <Button
                            variant="success"
                            onClick={() => dispatch(addModal({
                                key: "addProjectGroup",
                                content: <Edit groupId={0} />,
                            }))}
                        >
                            {lang.add}
                        </Button>
                    )}
                />
            </PageContent>
        </Container>
    )
}
export default ProjectGroup
